import { Globe, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function MyLocation() {
  return <section data-section-id="143713" id="hier-finden-sie-uns" className="relative w-full h-[500px] md:h-[600px] bg-background overflow-hidden">
      {}
      <iframe src="https://maps.google.com/maps?q=Gymnasialstraße%202%2055543%20Bad%20Kreuznach&t=&z=15&ie=UTF8&iwloc=&output=embed" className="absolute inset-0 w-full h-full grayscale contrast-125 opacity-80 border-0" allowFullScreen aria-hidden="true" title="Google Map" />
      
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,hsl(var(--background))_150%)]" />
      <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent" />

      {}
      <div className="absolute bottom-6 left-4 right-4 md:bottom-12 md:left-12 md:right-auto z-20">
        <Card className="bg-background/80 backdrop-blur-xl border-border/50 shadow-2xl max-w-sm mx-auto md:mx-0 overflow-hidden rounded-sm">
          <CardContent className="p-6 flex items-center gap-5">
            <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 rounded-sm bg-primary/10 text-primary ring-1 ring-primary/30 shadow-inner">
              <MapPin className="w-6 h-6 md:w-7 md:h-7" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg md:text-xl font-bold text-primary tracking-tighter font-sans uppercase">Bad Kreuznach&nbsp;</span>
              <span className="text-xs md:text-sm text-primary flex items-center gap-2 mt-1 font-mono uppercase tracking-wider">Gymnaasialstraße 2</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}